//export const HTTP_REQUEST = "http://localhost/api_debiteur/routeurApi.php";
export const HTTP_REQUEST = "https://www.anhod.com/api_debiteur/routeurApi.php";
//export const HTTP_REQUEST = "https://hypotheca.fr"; EN LIGNE
